import axios from 'axios'
import {AuthModel, UserModel} from './_models'
import api from '../../../services/service'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/login`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/auth/registro`
export const REQUEST_PASSWORD_URL = `${API_URL}/usuario/password/recuperar`
export const RESET_PASSWORD_URL = `${API_URL}/auth/reset-password`
export const CHANGE_PASSWORD_URL = `${API_URL}/auth/change-password`
export const GET_USER_PERMISSIONS_URL = `${API_URL}/auth/permissions`

// Server should return AuthModel
export function login(email: string, password: string) {
  return api.post(LOGIN_URL, {
    usuario: email,
    password,
  })
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return api.post<{result: boolean}>(`${REQUEST_PASSWORD_URL}/${email}`)
}

// Reset password with token
export function resetPassword(token: string, password: string) {
  return axios.post(RESET_PASSWORD_URL, {
    token,
    password,
  })
}

// Change password for authenticated user
export function changePassword(currentPassword: string, newPassword: string) {
  return api.post(CHANGE_PASSWORD_URL, {
    currentPassword,
    newPassword,
  })
}

export function getUserByToken(token: string) {
  return api.get(GET_USER_BY_ACCESSTOKEN_URL, {
    params: {
      token,
    },
  })
}

export function getUserPermissions() {
  return api.get(GET_USER_PERMISSIONS_URL)
}
